export default "Chauffe-eau solaire (CESI) 2026 — Aides MPR + CEE cumulables | Solution Éco France";
